<script>
    export let label = 'placeholder';
    export let labelClass;
    export let placeholder;
    export let id = '';
    export let value = '';
    export let error = '';
    export let errorMessage = '';
    export let className = '';
    export let type = 'text';
</script>

<div class={`main-map-fields ${className}`}>
    <div class="ctrl-holder main-map-address {error ? 'error' : ''}">
        <label for={id} class={labelClass}>{label}</label>
        {#if type === 'number'}
            <input
                type="number"
                {id}
                {placeholder}
                bind:value
                {...$$restProps}
            />
        {:else}
            <input type="text" {id} {placeholder} bind:value {...$$restProps} />
        {/if}
        {#if error}
            <label class="error" for="nombre">{errorMessage}</label>
        {/if}
    </div>
</div>

<style>
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type='number'] {
        -moz-appearance: textfield;
    }
</style>
